import script from "./CreateToken.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateToken.vue?vue&type=script&setup=true&lang=ts"

import "./CreateToken.vue?vue&type=style&index=0&id=591eff07&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591eff07"]])

export default __exports__